import capitalize from 'lodash/capitalize'

import { IMDTAirdropHistoryItemDTO } from 'interfaces/api/mdtBalance'

export const AccountType: TAnt.TableColumnRender<IMDTAirdropHistoryItemDTO['type']> = (type) => (
  <>{capitalize(type.name)}</>
)
